import { render, staticRenderFns } from "./AppointmentsEmpty.vue?vue&type=template&id=3567c14f"
import script from "./AppointmentsEmpty.vue?vue&type=script&lang=js"
export * from "./AppointmentsEmpty.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsEmpty.vue?vue&type=style&index=0&id=3567c14f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports